import React from 'react';

const TermsAndConditions = () => {
  return <h2>Terms & Conditions</h2>;
};

export default TermsAndConditions;
